'use strict';

import {EventEmitter} from 'events';
import assign from 'object-assign';
import TngAppDispatcher from '../dispatcher/TngAppDispatcher';
import processAction from 'services/storeUtils';

import appConstants from 'constants/appConstants';
import utils from 'services/utils';
import moment from 'moment';
import _ from 'underscore';

var _attachments = {};

var downloadReport = function (response) {
    
    const reportID = "{0}{1}{2}".format(response.queryParams.reportType, utils.stringify(response.queryParams.requestTeamType), utils.stringify(response.queryParams.teamId));

    if (!_attachments[reportID]) {
        _attachments[reportID] = {};
    }

    var actions = processAction(response, function (responseBody) {
        if (responseBody.status) {
            if (responseBody.status === 200) {
                utils.downloadFileAsCsv(responseBody.response, "{0}{1}{2}".format(response.queryParams.reportType, response.queryParams.teamSlug ? "-" + response.queryParams.teamSlug : "", "-" + moment().format(appConstants.dates.formats.SERVER_POST_FORMAT)));
                _attachments.error = null;
            } else {
                _attachments.error = responseBody.statusText;
            }
        }
    });

    if (actions.loading) {
        _attachments.error = null;
    }

    _attachments[reportID].loading = actions.loading;

};

var ReportsStore = assign({}, EventEmitter.prototype, {
    addChangeListener(callback) {
        this.on(appConstants.events.CHANGE, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(appConstants.events.CHANGE, callback);
    },
    getReportsState() {
        return _attachments;
    },
    isAnyReportsDownloading(reportIDs) {

        var isDownloading = false;

        _.each(reportIDs, (id) => {

            if (_attachments[id] && !isDownloading) {
                isDownloading = _attachments[id].loading;
            } 
        });

        return isDownloading;

    },   
});

ReportsStore.dispatchToken = TngAppDispatcher.register(function (payload) {
    var action = payload.action;
    switch (action.actionType) {

    case appConstants.actions.REPORTS.DOWNLOAD_REPORT:
        downloadReport(action);
        ReportsStore.emit(appConstants.events.CHANGE);
        break;

    case appConstants.actions.REPORTS.LEAVE_HISTORY_REPORT:
        downloadReport(action);
        ReportsStore.emit(appConstants.events.CHANGE);
        break;

    case appConstants.actions.REPORTS.LEAVE_BALANCE_REPORT:
        downloadReport(action);
        ReportsStore.emit(appConstants.events.CHANGE);
        break;

    case appConstants.actions.REPORTS.APPLIED_LEAVE_BY_DATE:
        downloadReport(action);
        ReportsStore.emit(appConstants.events.CHANGE);
        break;

    default:
        return true;

    }

    return true;
});

export default ReportsStore;
